import { useState, useEffect } from 'react';

export const useCloudNetworkStatus = (): boolean => {
  const [isOnline, setIsOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );
  
  useEffect(() => {
    const handleNetworkChange = () => {
      setIsOnline(navigator?.onLine ?? true);
    };
    
    window.addEventListener('online', handleNetworkChange);
    window.addEventListener('offline', handleNetworkChange);
    
    handleNetworkChange();
    
    return () => {
      window.removeEventListener('online', handleNetworkChange);
      window.removeEventListener('offline', handleNetworkChange);
    };
  }, []);
  
  return isOnline;
};

export default useCloudNetworkStatus;